import Recorder from "js-audio-recorder";
import { Message } from "element-ui";
class RecorderCls {
  constructor() {
    this.recorder = new Recorder();
  }
  // 权限检查
  async getPermission() {
    try {
      await Recorder.getPermission();
      return true;
    } catch (error) {
      console.log("error", error);
      let errorMsg = "";
      const errorString = error.toString();
      if (errorString.indexOf("NotFoundError") !== -1) {
        errorMsg = "麦克风未找到，请检查麦克风是否正常";
      } else {
        errorMsg = "麦克风权限未开启";
      }
      Message.error(errorMsg);
      return false;
    }
  }
  // 开始录音
  start() {
    return this.recorder.start();
  }
  // 结束录音
  stop() {
    this.recorder.stop();
  }
  // 播放录音
  play() {
    this.recorder.play();
  }
  // 获取音频
  getBlob() {
    return this.recorder.getWAVBlob();
  }
  // 获取时长
  getDuration() {
    return this.recorder.duration;
  }
  // 获取文件大小
  fileSize() {
    return this.recorder.fileSize;
  }
}

export default new RecorderCls();
